import { useTranslation } from 'react-i18next'

import { Button, Modal } from 'semantic-ui-react'

export default function FiltersModal ({ children, open, onCancel, onApply, setFilters }) {
  const { t } = useTranslation()

  const onHandle = (fn) => {
    return () => {
      if (typeof fn === 'function') {
        fn()
      }
    }
  }

  const onResetFilters = () => {
    setFilters({})
  }

  return (
    <Modal open={open}>
      <Modal.Header className='bg-info'>
        <p>Filtros avanzados</p>
      </Modal.Header>
      <Modal.Content>
        { children }
      </Modal.Content>
      <Modal.Actions>
        <Button
          color='teal'
          labelPosition='left'
          icon='remove circle'
          content={t('generic.clearFilters')}
          type='button'
          onClick={onHandle(onResetFilters)}
        />
        <Button
          color='grey'
          labelPosition='left'
          icon='arrow alternate circle left'
          content={ t('generic.cancel') }
          type='button'
          onClick={onHandle(onCancel)}
        />
        <Button
          color='green'
          labelPosition='left'
          icon='options'
          content={ t('generic.apply') }
          type='button'
          onClick={onHandle(onApply)}
        />
      </Modal.Actions>
    </Modal>
  )
}
